import Vue from 'vue'

Vue.filter('truncateText', (str, length) => {
  if (!str) return ''

  if (str.length <= length) return str

  return str.slice(0, length) + '...'
})
